<template>
    <svg
        v-if="!blackout"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M8.6479 3.31458C6.99422 3.31456 5.68379 3.31455 4.65806 3.44863C3.6036 3.58646 2.74499 3.87707 2.06533 4.53785C1.38292 5.20131 1.08028 6.04395 0.937235 7.07837C0.798798 8.07944 0.798812 9.35675 0.798828 10.9612V11.0685C0.798812 12.6729 0.798798 13.9503 0.937235 14.9513C1.08028 15.9857 1.38292 16.8284 2.06533 17.4918C2.74499 18.1526 3.6036 18.4432 4.65806 18.5811C4.92236 18.6156 5.20556 18.6413 5.50866 18.6603C4.89215 18.2581 4.38781 17.6983 4.05278 17.0381C3.60381 16.9103 3.29095 16.7308 3.04128 16.488C2.66924 16.1263 2.44465 15.6314 2.32409 14.7595C2.20045 13.8655 2.19888 12.6852 2.19888 11.0148C2.19888 9.34454 2.20045 8.16421 2.32409 7.27015C2.44465 6.39831 2.66924 5.90338 3.04128 5.54168C3.41607 5.1773 3.93325 4.95533 4.83952 4.83687C5.76395 4.71603 6.98274 4.71463 8.69911 4.71463H12.2992C14.0156 4.71463 15.2344 4.71603 16.1588 4.83687C17.0651 4.95533 17.5823 5.1773 17.9571 5.54168C18.2476 5.82413 18.4482 6.18782 18.5796 6.7488C19.1084 6.78343 19.6104 6.91592 20.0679 7.12834C20.0657 7.1116 20.0634 7.09495 20.0611 7.07837C19.9181 6.04395 19.6154 5.20131 18.933 4.53785C18.2533 3.87707 17.3947 3.58646 16.3403 3.44863C15.3146 3.31455 14.0041 3.31456 12.3504 3.31458H8.6479Z"
            fill="currentColor"
        />
        <path
            d="M19.2039 10.0998C19.2039 10.7957 18.6136 11.3599 17.8853 11.3599C17.157 11.3599 16.5666 10.7957 16.5666 10.0998C16.5666 9.40391 17.157 8.83977 17.8853 8.83977C18.6136 8.83977 19.2039 9.40391 19.2039 10.0998Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.7547 5.8183C17.7532 5.68963 16.4736 5.68964 14.858 5.68966H11.2424C9.62685 5.68964 8.3472 5.68963 7.34572 5.8183C6.31504 5.95071 5.48082 6.22969 4.82293 6.85834C4.16504 7.48699 3.87308 8.28413 3.73451 9.269C3.59986 10.226 3.59987 11.4487 3.59989 12.9925V13.0873C3.59987 14.6311 3.59986 15.8539 3.73451 16.8108C3.87308 17.7957 4.16504 18.5928 4.82293 19.2215C5.48082 19.8501 6.31504 20.1291 7.34571 20.2615C8.3472 20.3902 9.62685 20.3902 11.2424 20.3902H14.858C16.4736 20.3902 17.7532 20.3902 18.7547 20.2615C19.7854 20.1291 20.6196 19.8501 21.2775 19.2215C21.9354 18.5928 22.2274 17.7957 22.3659 16.8108C22.5006 15.8539 22.5006 14.6311 22.5006 13.0873V12.9925C22.5006 11.4488 22.5006 10.226 22.3659 9.269C22.2274 8.28413 21.9354 7.48699 21.2775 6.85834C20.6196 6.22969 19.7854 5.95071 18.7547 5.8183ZM7.52142 7.0671C6.63697 7.18073 6.1274 7.39382 5.75536 7.74933C5.38331 8.10484 5.16031 8.59176 5.0414 9.4369C4.94602 10.1148 4.92468 10.9621 4.91991 12.0703L5.36487 11.6982C6.42719 10.81 8.02828 10.861 9.02641 11.8148L12.7975 15.4182C13.1751 15.7791 13.7695 15.8283 14.2064 15.5349L14.4685 15.3588C15.7259 14.5144 17.4271 14.6123 18.5694 15.5946L20.8447 17.5514C20.9377 17.3027 21.008 17.0058 21.059 16.6429C21.1805 15.7797 21.1819 14.6417 21.1819 13.0399C21.1819 11.4381 21.1805 10.3002 21.059 9.4369C20.9401 8.59176 20.7171 8.10484 20.3451 7.74933C19.973 7.39382 19.4635 7.18073 18.579 7.0671C17.6756 6.95104 16.4847 6.9497 14.8084 6.9497H11.292C9.61573 6.9497 8.42484 6.95104 7.52142 7.0671Z"
            fill="currentColor"
        />
    </svg>
    <svg
        v-else
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.66699 9.22621C1.66699 6.6073 1.66699 5.29784 2.50383 4.48425C3.34067 3.67065 4.68754 3.67065 7.38128 3.67065H10.2384C12.9322 3.67065 14.279 3.67065 15.1159 4.48425C15.9527 5.29784 15.9527 6.6073 15.9527 9.22621C15.9527 11.8451 15.9527 13.1546 15.1159 13.9682C14.279 14.7818 12.9322 14.7818 10.2384 14.7818H7.38128C4.68754 14.7818 3.34067 14.7818 2.50383 13.9682C1.66699 13.1546 1.66699 11.8451 1.66699 9.22621Z"
            stroke="white"
            stroke-width="1.18"
        />
        <path
            d="M4.04785 11.6071C4.04785 8.98816 4.04785 7.6787 4.88469 6.86511C5.72153 6.05151 7.0684 6.05151 9.76214 6.05151H12.6193C15.313 6.05151 16.6599 6.05151 17.4967 6.86511C18.3336 7.6787 18.3336 8.98816 18.3336 11.6071C18.3336 14.226 18.3336 15.5354 17.4967 16.349C16.6599 17.1626 15.313 17.1626 12.6193 17.1626H9.76214C7.0684 17.1626 5.72153 17.1626 4.88469 16.349C4.04785 15.5354 4.04785 14.226 4.04785 11.6071Z"
            fill="#222222"
            stroke="white"
            stroke-width="1.18"
        />
        <ellipse
            cx="14.7618"
            cy="8.82939"
            rx="1.19048"
            ry="1.19048"
            fill="#222222"
            stroke="white"
            stroke-width="1.18"
        />
        <path
            d="M4.04785 11.6669L5.29167 10.4658C5.93877 9.84087 6.91405 9.87671 7.52205 10.5477L10.5682 13.9095C11.0562 14.4481 11.8244 14.5215 12.3891 14.0836L12.6008 13.9193C13.4134 13.2891 14.5127 13.3622 15.2509 14.0954L17.5399 16.369"
            stroke="white"
            stroke-width="1.18"
            stroke-linecap="round"
        />
    </svg>
</template>

<script>
export default {
    name: "PhotosIcon",
    props: {
        blackout: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
